var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBookBookmark = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 2.68005H8C6.392 2.68005 4 3.74539 4 6.68005V10.6801V18.6801V22.6801V25.3467C4 28.2814 6.392 29.3467 8 29.3467H28V26.6801H8.016C7.4 26.6641 6.66667 26.4201 6.66667 25.3467C6.66667 25.2121 6.67867 25.0921 6.69867 24.9827C6.848 24.2161 7.476 24.0267 8.01467 24.0134H26.6667C26.6907 24.0134 26.708 24.0014 26.732 24.0001H28V22.6801V20.0001V5.34672C28 3.87605 26.804 2.68005 25.3333 2.68005ZM25.3333 21.3467H6.66667V18.6801V10.6801V6.68005C6.66667 5.60539 7.4 5.36272 8 5.34672H17.3333V14.6801L20 13.3467L22.6667 14.6801V5.34672H25.3333V20.0001V21.3467Z",
    fill: "#08C5A7"
  })));
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookBookmark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/book-bookmark.d9cd5e0c.svg";
export { ForwardRef as ReactComponent };